import { Pipe, PipeTransform } from '@angular/core';
import { ChampLibre } from '../models/champLibre';

@Pipe({
  name: 'iahResiduelStatut',
  standalone: true
})
export class IahResiduelStatutPipe implements PipeTransform {

  transform(iahResiduel?: ChampLibre, ...args: unknown[]): 'success' | 'warning' | 'error' | 'info' {
    return iahResiduel ?
      typeof iahResiduel.value == 'number' && iahResiduel!.value <= 10
        ? 'success'
        : 'error'
      : 'warning'
  }

}
